import { render, staticRenderFns } from "./CSSCode.vue?vue&type=template&id=dc670542&"
import script from "./CSSCode.vue?vue&type=script&lang=js&"
export * from "./CSSCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports